import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import type { CounterNodeData, SidebarComponentProps } from '../types'
import { v2validations } from '../config/validation.config'
import { GenericSidebarComponent } from './sidebar.base'

type FormValues = CounterNodeData['config']

const fields = (nodeVars: string[]): GenericFieldConfig<FormValues> => {
  const validations = v2validations({ nodeVars }).counter
  return [
    {
      name: 'name',
      componentType: 'input',
      label: 'Name',
      zodValidation: validations.shape.name,
      inputProps: {
        placeholder: 'Enter name',
      },
    },
    {
      name: 'max_count',
      label: 'Enter number of times to count',
      zodValidation: validations.shape.max_count,
      componentType: 'inputNumber',
      inputProps: {
        type: 'number',
        endIcon: <span className="text-tertiary text-p-400 mr-7">times</span>,
        min: 0,
      },
    },
  ]
}

// NODE_GEN: Update this code, do not commit directly
// Remove this comment after updating the code

export const CounterSidebarComponent = (props: SidebarComponentProps<CounterNodeData>) => {
  const { nodeVars } = props
  const formFields = fields(nodeVars)

  return <GenericSidebarComponent fields={formFields} {...props} />
}
